'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardContextProvider = exports.CardContext = exports.compactCardContext = exports.defaultCardContext = undefined;

var _react = require('react');

var defaultCardContext = exports.defaultCardContext = {
  compact: false
};

var compactCardContext = exports.compactCardContext = { compact: true };

var CardContext = exports.CardContext = (0, _react.createContext)(defaultCardContext);

var Provider = CardContext.Provider;
exports.CardContextProvider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/context/CardContext.js
// module id = 217
// module chunks = 177